module.exports = __webpack_public_path__ + "media/more_info/chat-af980bfc.png";